import React from 'react';
import StudioPanel from '../../components/studio/StudioPanel';

/**
 * TEMPORARY diagnostic route for the Studio shell.
 *
 * StudioPanel only mounts inside the auth-gated chat, which makes a visual regression in it impossible to
 * see without signing in. This renders it directly so the layout can be inspected in a browser. It performs
 * no auth and its service calls simply fail — the point is the SHELL, not the data.
 */
const StudioSpike: React.FC = () => (
  <StudioPanel open onClose={() => {}} uid="spike-user" initialIdea="A courier misses the last train home." />
);

export default StudioSpike;
